<template>
  <div class="paginationBox pageSection clearFix right">
    <div
      class="left rangeText"
      v-if="totalFlag">{{rangeText}}</div>
    <div
      class="inputPageModule left clearFix"
      v-if="inputPageModule">
      <input
        type="text"
        v-model="initCurrentPage"
        @keyup="checkNumber"
        @keyup.enter="jumpTo('0')"
        @blur="inserDefaultVal"
        class="left currentPage">
      <!-- gotoPageBtn -->
      <div
        class="left iconfont icon-jump pageIcon gotoPageBtn"
        :class="{notAllowed: userJump}"
        @click="jumpTo('0')"
        :title="$t('lang.i18n_jump')"></div>
    </div>
    <!-- firstIcon -->
    <div
      class="left pageIcon iconfont icon-a-tothefirst"
      :class="{notAllowed: userChangePagePre}"
      :title="$t('lang.i18n_first')"
      @click="jumpTo('1')"></div>
    <!-- previousIcon -->
    <div
      class="left pageIcon iconfont icon-previous"
      :class="{notAllowed: userChangePagePre}"
      :title="$t('lang.i18n_pre')"
      @click="jumpTo('2')"></div>
    <div class="left pageNum">{{pageNum}}</div>
    <!-- nextIcon -->
    <div
      class="left pageIcon iconfont icon-next"
      :class="{notAllowed: userChangePageNext}"
      :title="$t('lang.i18n_next')"
      @click="jumpTo('3')"></div>
    <!-- lastIcon -->
    <div
      class="left pageIcon iconfont icon-a-tothelast"
      :class="{notAllowed: userChangePageNext}"
      :title="$t('lang.i18n_last')"
      @click="jumpTo('4')"></div>
    <el-dropdown
      class="page_dropdown"
      v-if="pageDropdownFlag"
      split-button
      type="primary"
      @command="handleCommand">

      <span class="el-dropdown-link">
        {{initCurrentSize}}
      </span>
      <el-dropdown-menu
        slot="dropdown"
        class="page_dropdown_menu">
        <el-dropdown-item
          v-for="item in pageSizes"
          :key="item"
          :command="item">
          {{item}}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { myReceiversAnalyze } from '@/assets/js/googleAnalyze/myReceiver.js'
export default {
  props: {
    currentPage: Number, // 当前第几页
    pageSize: Number, // 每页显示多少条
    pageSizes: { // 下拉框可选数据
      type: Array,
      default: () => {
        return [10, 20, 50, 80]
      }
    },
    layout: { // 控制分页功能
      default: 'total, prev, pageF, next, pageL ,sizes, nowSize, jumper'
    },
    total: Number // 总数据
  },
  data () {
    return {
      inputPageModule: true,
      pageDropdownFlag: true,
      totalFlag: true,
      initCurrentPage: 1, // 用户操作后的新值与currentPage做对比
      initCurrentSize: 10, // 用户操作后的新值与currentSize做对比
      userChangePagePre: true, // 上一页及跳转到第一页是否可使用
      userChangePageNext: false, // 下一页及跳转到最后一页是否可使用
      userChangePageSize: true, // 每页显示数据是否有修改
      userJump: false, // 跳转是否可使用
      lastFlag: false // 是否为最后一页
    }
  },
  mounted () {
    this.inputPageModule = this.layout.indexOf('jumper') > -1
    this.pageDropdownFlag = this.layout.indexOf('sizes') > -1
    this.totalFlag = this.layout.indexOf('total') > -1
    this.initCurrentPage = this.currentPage
    this.initCurrentSize = this.pageSize
    this.initPage()
  },
  computed: {
    pageNum: {
      get: function () {
        return this.currentPage + '/' + Math.ceil(this.total / this.pageSize)
      }
    },
    rangeText () {
      const t = this.total || 0
      const start = t === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1
      const end = Math.min(this.currentPage * this.pageSize, t)
      return this.$t('lang.i18n_pageRange', { start, end, total: t })
    }
  },
  watch: {
    total: {
      handler (val) {
        this.initPage()
      }
    },
    currentPage: {
      handler (val) {
        this.initCurrentPage = val
        this.initPage()
      }
    },
    pageSize: {
      handler (val) {
        this.initCurrentSize = val
        this.initPage()
      }
    },
    initCurrentPage: {
      handler (val) {
        this.userJump = this.initCurrentPage == ''
      }
    }
  },
  methods: {
    // 组件初始化
    initPage () {
      const maxSize = Math.ceil(this.total / this.pageSize)
      if (maxSize == 1) {
        this.userChangePageNext = true
        this.userChangePagePre = true
        this.userJump = true
      } else if (maxSize < 1) {
        this.userChangePageNext = true
        this.userChangePagePre = true
        this.userJump = true
      } else if (this.currentPage == 1 && maxSize > 1) {
        this.userChangePageNext = false
        this.userChangePagePre = true
        this.userJump = false
      } else if (this.currentPage == maxSize && maxSize != 1) {
        this.userChangePageNext = true
        this.userChangePagePre = false
        this.userJump = true
      } else {
        this.userChangePageNext = false
        this.userChangePagePre = false
        this.userJump = false
      }
    },
    // 控制跳转页的输入
    checkNumber () {
      const maxSize = Math.ceil(this.total / this.pageSize)
      if (this.initCurrentPage === null || this.initCurrentPage > maxSize) {
        this.initCurrentPage = maxSize + ''
        return
      }
      const str = this.initCurrentPage.toString()
      this.initCurrentPage = str.replace(/[^\d]|(^0+)/g, '') // 控制只能输入正整数
    },
    // 点击下拉框
    handleCommand (command) {
      if (this.pageSize == command) {
        this.userChangePageSize = false
        return
      }
      const MaxPage = Math.ceil(this.total / command)
      this.userJump = MaxPage == 1
      this.userChangePagePre = MaxPage == 1
      this.userChangePageNext = MaxPage == 1
      this.userChangePageSize = true
      this.initCurrentPage = this.currentPage > MaxPage ? MaxPage : this.currentPage
      this.lastFlag = this.currentPage > MaxPage
      this.userChangePagePre = this.initCurrentPage == 1
      this.userChangePageNext = this.currentPage >= MaxPage
      this.initCurrentSize = command
      this.emitChange()
    },
    // 跳转
    jumpTo (num) { // 0 跳转到任意一页；1 跳转到首页； 2 上一页； 3 下一页； 4 跳转到最后一页
      let flag = true
      const maxSize = Math.ceil(this.total / this.pageSize)
      if (this.initCurrentPage < 1 || this.initCurrentPage > maxSize) {
        return
      }
      this.userChangePageSize = false
      this.userChangePagePre = maxSize == 1
      this.userChangePageNext = maxSize == 1
      this.userJump = maxSize == 1 // userJump/userChangePagePre/userChangePageNext为true表示不可用
      if (maxSize == 1) return
      switch (num) {
        case '0':
          if (this.userJump) return
          if (this.initCurrentPage == 1 && maxSize != 1) {
            this.userChangePagePre = true
            this.userChangePageNext = false
          }
          if (this.initCurrentPage == maxSize && maxSize != 1) {
            this.userChangePagePre = false
            this.userChangePageNext = true
          }
          break
        case '1':
          if (this.userChangePagePre) return
          this.initCurrentPage = 1
          this.userChangePagePre = true
          this.userChangePageNext = false
          break
        case '2':
          if (this.userChangePagePre) return
          this.userChangePagePre = this.currentPage - 1 <= 1
          myReceiversAnalyze('myReceiversNavPagePrevious', this.$route.path) // 谷歌统计 上一页
          this.userChangePageNext = false
          if (this.currentPage - 1 < 1) {
            flag = false
          } else { this.initCurrentPage = this.currentPage - 1 }
          break
        case '3':
          if (this.userChangePageNext) {
            return
          }
          this.userChangePageNext = this.currentPage + 1 >= maxSize
          myReceiversAnalyze('myReceiversNavPageNext', this.$route.path) // 谷歌统计 上一页
          this.userChangePagePre = false
          if (this.currentPage + 1 > maxSize) {
            flag = false
            this.lastFlag = true
          } else { this.initCurrentPage = this.currentPage + 1 }
          break
        case '4':
          if (this.userChangePageNext) {
            return
          }
          this.initCurrentPage = maxSize
          this.userChangePageNext = true
          this.userChangePagePre = false
          this.lastFlag = true
          break
        default: break
      }
      if (flag) {
        this.emitChange()
      }
    },
    // 向父级发送当前变化
    emitChange () {
      this.$nextTick(() => {
        if (this.initCurrentPage !== this.currentPage) {
          if (!(this.userChangePageSize && this.initCurrentPage <= this.currentPage)) {
            this.$emit('current-change', Number(this.initCurrentPage))
          }
        }
        if (this.userChangePageSize) {
          this.$emit('size-change', Number(this.initCurrentSize))
        }
      })
    },
    inserDefaultVal () { // 输入为空时 填充当前页码到输入框
      if (!this.initCurrentPage) {
        const currentPageN = this.pageNum.split('/')[0]
        this.initCurrentPage = currentPageN
      }
    }
  }
}
</script>
<style lang="less" scoped>
.paginationBox {
  float: right;
  line-height: 32px;
  height: 32px;
  text-align: right;
  font-size: 12px;
  // margin-top: 8px;
  .left {
    float: left;
  }
  .rangeText {
    margin-right: 8px;
    font-size: 14px;
    line-height: 32px;
  }
  .pageIcon {
    cursor: pointer;
    width: 28px;
    font-size: 24px;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    margin-left: 2px;
    margin-right: 2px;
    color: #39aa50;
    &.notAllowed {
      cursor: not-allowed;
      color: #434443;
    }
    &.gotoPageBtn {
      &:hover {
        color: #fbfbfb;
      }
      &.notAllowed {
        color: #39aa50;
      }
    }
  }
  .currentPage {
    width: 30px;
    text-align: center;
    height: 100%;
    background-color: #444;
    color: #dbdbdb;
    outline: none;
    border: none;
    border-radius: 4px 0 0 4px;
  }
  .gotoPageBtn {
    width: 28px;
    height: 100%;
    cursor: pointer;
    background-color: #444;
    margin-left: 0;
    padding-right: 5px;
    border-radius: 0 4px 4px 0;
    font-size: 20px;
  }
  .inputPageModule {
    margin-right: 8px;
    height: 100%;
  }
  .everyPageNum {
    height: 100%;
    margin-left: 6px;
    border-color: #d3d3d3;
    font-size: 12px;
    width: 60px;
    text-align: center;
    .dropdownDefault_value {
      font-size: 12px;
      text-align: center;
      text-indent: 0.2em;
    }
    .downArrow {
      right: 10px;
    }
  }
  .pageNum {
    margin: 0 6px;
    min-width: 24px;
  }

  ::v-deep .el-dropdown.page_dropdown {
    margin-top: 0;
    margin-left: 8px;
    .el-button--primary {
      height: 28px;
      line-height: 28px;
      padding: 0 6px;
      border: none;
    }
  }
  ::v-deep .el-dropdown .el-dropdown__caret-button::before {
    display: none;
  }
}
</style>
